<greco-box>
  <div class="box-header">
    <mat-icon *ngIf="icon" class="icon background">{{ icon }}</mat-icon>
    <h3 *ngIf="promoTitle">{{ promoTitle }}</h3>
  </div>
  <p *ngIf="subtitle">{{ subtitle }}</p>
</greco-box>
